import { Component, Input, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label, Color } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import 'chartjs-plugin-labels';

@Component({
  selector: 'app-stackedbar-chart',
  templateUrl: './stackedbar-chart.component.html',
  styleUrls: ['./stackedbar-chart.component.scss'],
})
export class StackedbarChartComponent implements OnInit {
  @Input() salesChartData: ChartDataSets[] = [];
  @Input() salesBarChartLabels: Label[] = [];
  @Input() isLoading: boolean = false;
  @Input() salesData: any[] = [];
  @Input() monthData: any[] = [];

  thisAsThat = (callBack: Function) => {
    const self = this;
    return function () {
      return callBack.apply(self, [this].concat(Array.prototype.slice.call(arguments)));
    };
  };

  barChartOptions: ChartOptions = {
    plugins: { showActualPercentages: false, labels: false },
    tooltips: {
      enabled: false,
      // position: 'nearest',
      custom: this.thisAsThat((that, tooltipModel) => {
        // let tooltipEl = document.getElementById('chart-tooltip');
        let tooltipEl = document.getElementById('chartjs-tooltip');

        if (!tooltipModel.dataPoints) {
          if (tooltipEl) tooltipEl.classList.add('d-none');

          return;
        }

        const data = {
          cost: 0,
          profit: 0,
          loss: 0,
          month: '',
          sales: 0,
        };

        if (tooltipModel.dataPoints) {
          const [dataPoint] = tooltipModel.dataPoints;

          if (dataPoint.index >= 0) {
            data.cost = that._data.datasets[0].data[dataPoint.index];
            data.profit = that._data.datasets[1].data[dataPoint.index];
            data.loss = that._data.datasets[2].data[dataPoint.index];

            if (this.salesData && this.salesData.length) {
              data.sales = this.salesData[dataPoint.index];
            }

            if (this.monthData && this.monthData.length) {
              data.month = this.monthData[dataPoint.index];
            }
          }
        }

        if (!tooltipEl) {
          tooltipEl = document.createElement('div');
          tooltipEl.id = 'chartjs-tooltip';
          // document.getElementById('chartjs-tooltip').appendChild(tooltipEl);

          document.body.appendChild(tooltipEl);
        }

        tooltipEl.classList.remove('d-none');
        tooltipEl.innerHTML = `
  <div class="tooltip-wrapper chart-tooltip">
  <div class="chart-tooltip-inner">
    <div class="ui-tooltip-arrow"></div>
    <div class="tooltip-header flex-start-center font-14">
      <i class="fal fa-chart-bar"></i>
      <span class="font-bold font-secondary-800">${data.month}</span>
    </div>

    <div class="tooltip-body">
      <div class="sales tooltip-row">
        <div class="tooltip-icon"><i class="fal fa-cash-register"></i> Sales</div>
        <div class="tooltip-amount">
          $${Number(data.sales || 0).toFixed(2)}
        </div>
      </div>

      <div class="cost tooltip-row">
        <div class="tooltip-icon"><i class="fal fa-coins"></i> Cost <span class="circle"></span></div>
        <div class="tooltip-amount">
          $${Number(data.cost || 0).toFixed(2)}
        </div>
      </div>

      <div class="profit tooltip-row">
        <div class="tooltip-icon"><i class="fal fa-usd-circle"></i> Gross Profit <span class="circle"></span>
        </div>
        <div class="tooltip-amount">
          $${Number(data.profit || 0).toFixed(2)}
        </div>
      </div>
      ${
        data.loss
          ? `
      <div class="profit tooltip-row">
        <div class="tooltip-icon"><i class="fal fa-usd-circle"></i> Gross Loss <span class="circle"></span>
        </div>
        <div class="tooltip-amount">
          $${Number(data.loss || 0).toFixed(2)}
        </div>
      </div>
      `
          : ''
      }
    </div>
  </div>
</div>`;

        // `this` will be the overall tooltip
        var position = that._chart.canvas.getBoundingClientRect();

        // Display, position, and set styles for font
        tooltipEl.style.opacity = '1';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.left = position.left - 62 + window.pageXOffset + tooltipModel.caretX + 'px';
        tooltipEl.style.top = position.top - 140 + window.pageYOffset + tooltipModel.caretY + 'px';
        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
        tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        tooltipEl.style.pointerEvents = 'none';
      }),
    },
    scales: {
      xAxes: [
        {
          // barThickness: 60,
          // maxBarThickness: 60,
        },
      ],
      yAxes: [{ stacked: true }],
    },
    responsive: true,
    legend: {
      position: 'bottom',
      labels: {
        fontSize: 10,
        usePointStyle: true,
      },
    },
  };
  colors: Color[] = [
    {
      backgroundColor: 'rgba(0, 193, 157, 0.6)',
      borderColor: 'rgba(0, 193, 157, 1)',
      hoverBackgroundColor: 'rgba(0, 193, 157, 0.8)',
      hoverBorderColor: 'rgba(0, 193, 157, 1)',
    },
    {
      backgroundColor: 'rgba(0, 143, 116, 0.6)',
      borderColor: 'rgba(0, 143, 116, 1)',
      hoverBackgroundColor: 'rgba(0, 143, 116, 0.8)',
      hoverBorderColor: 'rgba(0, 143, 116, 1)',
    },
    {
      backgroundColor: 'rgba(189, 9, 6, 0.6)',
      borderColor: 'rgba(189, 9, 6, 1)',
      hoverBackgroundColor: 'rgba(189, 9, 6, 0.8)',
      hoverBorderColor: 'rgba(189, 9, 6, 1)',
    },
  ];
  barChartLegend = true;
  barChartPlugins = [pluginAnnotations];
  barChartType: ChartType = 'bar';

  constructor(private currencyPipe: CurrencyPipe) {}

  ngOnInit() {}

  chartClicked(event: any): void {}

  chartHovered(event: any): void {}
}
